import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';

import { PRIMARY_COLORS } from '../../../themes/light';

const CELL_PADDING = '4px 16px';
const CELL_HEIGHT = 52;

export const StyledTable = styled(Table)({
  borderCollapse: 'separate',
});

export const StyledTableHead = styled(TableHead)({
  '& th': {
    backgroundColor: PRIMARY_COLORS.PRIMARY_WHITE,
    color: PRIMARY_COLORS.PRIMARY_GREEN,
    padding: CELL_PADDING,
    height: CELL_HEIGHT,
    border: 'none',

    '&.sortable': {
      position: 'relative',

      '&:hover': {
        '& .hover-arrow': {
          opacity: 0.5,
          visibility: 'visible',
        },
      },
    },
  },
});

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 1px;
  height: 100%;
  overflow-y: auto;
`;

export const SearchBarContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  gridTemplateColumns: '1fr 1fr 1fr 120px',
  backgroundColor: theme.palette.background.paper,
}));

export const SearchBarContainerInner = styled(SearchBarContainer)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 2,
}));

export const TypingBlock = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(p) => p.theme.spacing(2)};
`;

export const tablePaginationStyles = {
  minHeight: '52px',

  '.MuiTablePagination-spacer': {
    display: 'none',
  },

  '.MuiToolbar-root': {
    paddingLeft: '16px',
  },

  '.MuiTablePagination-input': {
    marginRight: 'auto',
  },
};
